import React from 'react';
import { Globe, Mail, Phone, MapPin } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Logo size="small" variant="footer" />
            <p>Navigate Your Next with confidence and innovation</p>
            <p>Empowering enterprises globally with cutting-edge technology solutions and digital transformation expertise.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Services</h4>
              <ul>
                <li><button onClick={() => handleLinkClick('/ai-machine-learning')}>AI & Machine Learning</button></li>
                <li><button onClick={() => handleLinkClick('/cloud-services')}>Cloud Services</button></li>
                <li><button onClick={() => handleLinkClick('/cybersecurity')}>Cybersecurity</button></li>
                <li><button onClick={() => handleLinkClick('/data-analytics')}>Data & Analytics</button></li>
                <li><button onClick={() => handleLinkClick('/digital-transformation')}>Digital Transformation</button></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Industries</h4>
              <ul>
                <li><button onClick={() => handleLinkClick('/banking-financial-services')}>Banking & Financial</button></li>
                <li><button onClick={() => handleLinkClick('/healthcare-life-sciences')}>Healthcare & Life Sciences</button></li>
                <li><button onClick={() => handleLinkClick('/manufacturing')}>Manufacturing</button></li>
                <li><button onClick={() => handleLinkClick('/retail')}>Retail & Consumer</button></li>
                <li><button onClick={() => handleLinkClick('/energy')}>Energy & Utilities</button></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li><button onClick={() => handleLinkClick('/about')}>About Us</button></li>
                <li><button onClick={() => handleLinkClick('/careers')}>Careers</button></li>
                <li><button onClick={() => handleLinkClick('/insights')}>Insights</button></li>
                <li><button onClick={() => handleLinkClick('/contact')}>Contact</button></li>
                <li><button onClick={() => handleLinkClick('/about')}>Global Presence</button></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-contact">
            <h4>Global Headquarters</h4>
            <div className="contact-item">
              <MapPin size={16} />
              <span>Kuala Lumpur, Malaysia</span>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <span>+60 3 2161 2888</span>
            </div>
            <div className="contact-item">
              <Mail size={16} />
              <span>info@auvsys.com</span>
            </div>
            <div className="contact-item">
              <Globe size={16} />
              <span>www.auvsys.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-legal">
            <p>&copy; 2020 AuVSys Global Technology Services. All rights reserved.</p>
            <div className="legal-links">
              <button onClick={() => handleLinkClick('/privacy')}>Privacy Policy</button>
              <button onClick={() => handleLinkClick('/terms')}>Terms of Service</button>
              <button onClick={() => handleLinkClick('/cookies')}>Cookie Policy</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;